module.exports = __webpack_public_path__ + "img/Our_Milestones_Background.9635c3d9.png";